<template>
  <div class="container-fluid page-container">
    <div class="row page-header__container mb-4 pb-3">
      <page-heading :class="'col-12'" :title="pageTitle" />
    </div>
    <div v-if="isProcessed">
      {{ $t('Thank you for giving us access to your Zoho CRM integration.') }}<br>
      {{ $t('Your Account Manager will be in touch to guide you through the next steps.') }}
    </div>
    <b-col v-else-if="busy" class="text-center">
      <spinner />
    </b-col>
    <div v-else>
      {{ $t('Sorry, there was an error.Please try again.') }}
    </div>
  </div>
</template>
<script>

import PageHeading from "@/components/control/PageHeading";
import Spinner from "@/components/animation/Spinner";
import company from "@/imports/mixins/company";

export default {
  name: "ZohoCRMIntegration",
  components: {PageHeading, Spinner},
  mixins:[company],
  data() {
    return {
      pageContent: null,
      pageTitle: 'Zoho CRM Integration',
      isProcessed: false,
      busy: false,
      error: false,
    }
  },
  methods: {
    getZohoToken(code) {
      this.busy = true;
      this.$api.leadSendToken.getZohoToken(code).then((response) => {
        this.busy = false;
        this.error = false;
        if (response.data.data && response.data.data.token) {
          this.isProcessed = true;
        }
        this.pageTitle = 'Zoho CRM Integration';
      })
        .catch((error) => {
          const defaultErrorMsg = this.$t('There was an error while processing your request');
          this.error = error.response.data.errors !== undefined ? error.response.data.errors[0] : defaultErrorMsg;
        })
        .finally(() => this.busy = false);
    }
  },
  mounted() {
    if (this.$route.query.code) {
      this.getZohoToken(this.$route.query.code);
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .table-border-pricing,
::v-deep .table-border-pricing td,
::v-deep .table-border-pricing th {
  border: 1px solid #dedede;
}
</style>
